// extracted by mini-css-extract-plugin
export var fileUpload = "_ej-1";
export var modalButton = "_ej-0";